export default __webpack_public_path__ + "static/media/ContentB3840.3798972d.png";